import React, { useState, useEffect } from "react";
import avatar_01 from "assets/videos/avatars/01.mp4";
import avatar_02 from "assets/videos/avatars/02.mp4";
import avatar_03 from "assets/videos/avatars/03.mp4";
import bgDesktop from "assets/images/bgs/purple_02_desktop.svg";
import bgMobile from "assets/images/bgs/purple_02_mobile.svg";

const testimonials = [
  {
    text: "BitBit Studio brought our ideas to life with stunning animations. Highly recommended!",
    name: "Alice Johnson",
    country: "USA",
    vid: avatar_01,
  },
  {
    text: "Their attention to detail and creativity is unmatched.",
    name: "Maria Mendes",
    country: "Brazil",
    vid: avatar_02,
  },
  {
    text: "Working with BitBit Studio was an absolute pleasure. Fantastic results!",
    name: "Emily Wong",
    country: "Australia",
    vid: avatar_03,
  },
];

const TestimonialCard = ({ text, name, country, vid }) => {
    return (
      <div
        className="flex flex-col justify-between p-6 bg-white border-[5px] border-[#FACC14] text-indigo-500 rounded-2xl shadow-lg text-center"
      >
        <video
          src={vid}
          alt={name}
          className="w-24 h-24 mx-auto rounded-full mb-4 object-cover"
          muted={true}
          autoPlay={true}
          loop={true}
        />
        <div>
          <p className="text-xl italic mb-4">"{text}"</p>
          <span className="block font-bold">{name}</span>
          <span className="block text-sm text-gray-500">{country}</span>
        </div>
      </div>
    );
  };

const Testimonials = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="relative mt-16 bg-contain bg-no-repeat bg-center"
      style={{
        backgroundImage: `url(${isMobile ? bgMobile : bgDesktop})`,
      }}
    >
      {/* Testimonials Section */}
      <div className="relative z-10 text-center py-16 px-8">
        {/* <h2 className="text-3xl font-title font-extrabold mb-6 uppercase tracking-wide text-white">
          What Our Clients Say
        </h2> */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-[90%] mx-auto">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} isMobile={isMobile}/>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
